import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import { deleteTenant, getTenantByID } from "./apiService";

const DeleteGuest = () => {
  const [guestname, setGuestname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [aadharno, setAadharno] = useState("");
  const [joindate, setJoindate] = useState("");
  const [rentamt, setRentamt] = useState("");
  //   const [balamt, setBalamt] = useState("");
  // const [paidstatus, setPaidstatus] = useState(false);
  // const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { guestid } = useAuth();

  useEffect(() => {
    getTenantByID(guestid)
      .then((res) => {
        setGuestname(res.name);
        setMobileno(res.mobileno);
        setAadharno(res.aadharNo);
        setJoindate(res.joinedDate);
        setRentamt(res.rentAmt);
      })
      .catch((e) => console.log(e));
  }, [guestid]);

  const handleTenantDelete = () => {
    let errors = {};

    // setErrors(errors);

    // console.log(Object.keys(fguests).length);
    try {
      if (Object.keys(errors).length === 0) {
        deleteTenant(guestid);

        setGuestname("");
        setMobileno("");
        setAadharno("");
        setJoindate("");
        setRentamt("");
        // setPaidstatus(false);
        navigate("/Dashboard/MyPGDetails/RoomDetails");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="container">
      <div className="header">DELETE GUEST</div>

      <div className="label">Guest Name: {guestname}</div>

      <div className="label">Mobile No: {mobileno}</div>

      <div className="label">Aadhar No: {aadharno}</div>

      <div className="label">Joining Date: {joindate}</div>

      <div className="label">Rent Amount: {rentamt}</div>
      <div className="errortext">
        <div>Please Verify The Guest Details Before Deleting it......!!!!</div>
        <div>Once Deleted can't Revert..!!</div>
      </div>

      <input
        type="submit"
        className="btn-cls"
        value="Delete"
        onClick={handleTenantDelete}
      />
    </div>
  );
};

export default DeleteGuest;
